import type { RankBadgeSize } from '@/components/social/shared/rank-badge';
import { cn } from '@/lib/ui/utils';

/** Typography matching `<RankBadge />` for plain numerals (no metallic clip). */
export function rankNumeralClassName(size: RankBadgeSize): string {
  return cn(
    'inline-flex min-w-[1ch] justify-center font-sans tabular-nums tracking-[-0.025em] leading-none font-medium',
    size === 'display' ? 'text-heading' : 'text-heading-md',
  );
}

/** 14px tabular rank numeral for DataTable rows ranked 4+ (matches non-table rank weight). */
export function rankCellNumeralClassName(): string {
  return 'inline-flex min-w-[1ch] justify-center font-sans text-body tabular-nums tracking-tight leading-none font-medium';
}
